<app-xy-line-plot
  [plotData]="plotData"
  class="block flex-1 min-h-0"
  [xAxisTitle]="xAxisTitle"
  [yAxisTitle]="yAxisTitle"
  [plotName]="'Temperature Deration'"
  [downloadPlotName]="downloadPlotName"
  [plotTitle]="'Temperature Deration'"
  [reverseAutoRange]="true"
></app-xy-line-plot>
